import images from "./images";

const campaigns = [
    {
        id: 1,
        image: images.campaign1,
        title: "Vehicle Upgrade",
        content: "Help us upgrade our emergency vehicles for quicker response times and improved community safety.",
        donation: {
            raised: 1000,
            goal: 2000
        },
        paragraphs: [
            "Help us upgrade our emergency vehicles for quicker response times and improved community safety. Help us upgrade our emergency vehicles for quicker response times and improved community safety.",
            "Your donation will contribute to enhancing our emergency services, ensuring safe and reliable transportation during critical situations."
        ],
        gallery: [
            images.campaign1Gallery1,
            images.campaign1Gallery2,
        ],
        objectives: [
            "Upgrade emergency vehicles for quick response.",
            "Enhance emergency services and efficiency.",
            "Ensure safe and reliable transportation.",
            "Improve emergency response time.",
            "Support disaster relief efforts."
        ],
        results: [
            "Your support will result in upgraded emergency vehicles, faster response times, and improved safety for our community during emergencies. Your support will result in upgraded emergency vehicles, faster response times, and improved safety for our community during emergencies."
        ]
    },
    {
        id: 2,
        image: images.campaign2,
        title: "Community CPR Training",
        content: "Help the community recover from disasters. Your contribution supports relief efforts and rehabilitation.",
        donation: {
            raised: 500,
            goal: 1500
        },
        paragraphs: [
            "Empower individuals with lifesaving CPR skills through our community training initiative. Immediate response can make the difference between life and death during emergencies.",
            "Your contribution enables us to provide free CPR training sessions, essential materials, and experienced instructors for widespread community impact."
        ],
        gallery: [
            images.campaign2Gallery1,
            images.campaign2Gallery2,
        ],
        objectives: [
            "Train community members in CPR techniques.",
            "Promote disaster preparedness and safety.",
            "Increase emergency response readiness.",
            "Support widespread public health initiatives.",
            "Build a safer, more resilient community."
        ],
        results: [
            "Thanks to your donation, more individuals will be equipped with CPR knowledge, helping to save lives during cardiac emergencies and natural disasters."
        ]
    },
    {
        id: 3,
        image: images.campaign3,
        title: "FireFighter Wellness",
        content: "Promote safety awareness in the community. Your contribution funds educational programs and workshops.",
        donation: {
            raised: 1200,
            goal: 2000
        },
        paragraphs: [
            "Support firefighter wellness and community safety by contributing to educational programs focused on mental health, physical fitness, and stress management.",
            "Your donation will help fund wellness workshops, safety training sessions, and awareness campaigns that benefit both first responders and the communities they protect."
        ],
        gallery: [
            images.campaign3Gallery1,
            images.campaign3Gallery2,
        ],
        objectives: [
            "Promote firefighter physical and mental wellness.",
            "Fund educational safety programs.",
            "Increase public awareness of fire prevention.",
            "Support workshops on stress management.",
            "Improve overall community safety and preparedness."
        ],
        results: [
            "Your support helps ensure firefighters remain physically fit, mentally healthy, and fully prepared to serve the community while encouraging public participation in safety practices."
        ]
    },
    {
        id: 4,
        image: images.campaign4,
        title: "Fire Safety Drills",
        content: "Ensure the well-being of the community. Your contribution supports health check camps.",
        donation: {
            raised: 800,
            goal: 2000
        },
        paragraphs: [
            "Participate in safeguarding your community by supporting our fire safety drill initiatives. These drills are vital for preparing citizens to act quickly and safely in emergencies.",
            "Donations will also help us organize health check-up camps for community members, ensuring their well-being and readiness during fire emergencies."
        ],
        gallery: [
            images.campaign4Gallery1,
            images.campaign4Gallery2,
        ],
        objectives: [
            "Conduct regular fire safety drills in communities.",
            "Educate the public on emergency evacuation procedures.",
            "Support health check-up camps during drills.",
            "Enhance preparedness during fire-related incidents.",
            "Foster community-wide safety awareness."
        ],
        results: [
            "With your support, we can improve emergency readiness and public health by running more fire safety drills and offering essential health services during these events."
        ]
    },
    {
        id: 5,
        image: images.campaign5,
        title: "Fire Department Upgrade",
        content: "Educate the community about fire safety. Your contribution funds awareness campaigns.",
        donation: {
            raised: 1500,
            goal: 2000
        },
        paragraphs: [
            "Help us strengthen our fire department by supporting vital upgrades and public education programs. An upgraded department ensures faster, more efficient responses during emergencies.",
            "Your donation will fund fire safety awareness campaigns, empowering the community with knowledge and resources to prevent and respond to fire hazards effectively."
        ],
        gallery: [
            images.campaign5Gallery1,
            images.campaign5Gallery2,
        ],
        objectives: [
            "Upgrade equipment and facilities in the fire department.",
            "Launch community-wide fire safety awareness campaigns.",
            "Educate the public about fire prevention techniques.",
            "Promote quick response strategies among citizens.",
            "Enhance the overall preparedness of the fire department."
        ],
        results: [
            "With your generous support, our fire department will be better equipped and our community more informed, resulting in a safer and more resilient environment for all."
        ]
    },
    {
        id: 6,
        image: images.campaign6,
        title: "Fire Department Gear",
        content: "Promote environmental sustainability. Your contribution supports green initiatives campaigns.",
        donation: {
            raised: 400,
            goal: 2000
        },
        paragraphs: [
            "Equip our firefighters with modern, eco-friendly gear while promoting sustainability within our operations. Your donation contributes to greener alternatives in firefighting practices.",
            "By supporting this initiative, you're helping us reduce environmental impact and lead the way in implementing sustainable solutions in emergency services."
        ],
        gallery: [
            images.campaign6Gallery1,
            images.campaign6Gallery2,
        ],
        objectives: [
            "Upgrade firefighting gear with eco-friendly alternatives.",
            "Implement green initiatives within fire department operations.",
            "Promote environmental awareness through campaigns.",
            "Support sustainable firefighting practices.",
            "Reduce carbon footprint in emergency responses."
        ],
        results: [
            "Your support will result in a better-equipped fire team and a positive step toward environmentally responsible emergency services that benefit the entire community."
        ]
    }

];

export default campaigns;